/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.1.0
 */

import { colors } from '../../../../../../theme';
import { EExpensesAnalyzerField } from '../../../ExpensesAnalyzerTable/types/expensesAnalyzerTableTypes';
import { IExpensesAnalyzerChartCategoryConfiguration } from '../expensesAnalyzerChartTypes';

export const ExpensesAnalyzerChartCategoryConfiguration: IExpensesAnalyzerChartCategoryConfiguration[] = [
    {
        key: EExpensesAnalyzerField.AMOUNT_COUNTRY_ROAMING,
        order: 6,
    },
    {
        key: EExpensesAnalyzerField.AMOUNT_LOCAL_MACRO,
        order: 5,
    },
    {
        key: EExpensesAnalyzerField.AMOUNT_ROAMING,
        order: 4,
    },
    {
        key: EExpensesAnalyzerField.AMOUNT_LOCAL,
        order: 3,
    },
    {
        key: EExpensesAnalyzerField.CHARGES,
        order: 2,
    },
    {
        key: EExpensesAnalyzerField.MONTH_CHARGE_SRLS,
        order: 1,
    },
    {
        key: EExpensesAnalyzerField.MONTH_CHARGE_RTPL,
        order: 0,
    },
];

export const ExpensesAnalyzerChartCategoryColorConfiguration = {
    [EExpensesAnalyzerField.CHARGES]: colors.chartCostsOneTimeCharges,
    [EExpensesAnalyzerField.MONTH_CHARGE_SRLS]: colors.chartCostsOtherRecurringCharges,
    [EExpensesAnalyzerField.MONTH_CHARGE_RTPL]: colors.chartCostsRecurringChargesForRatePlan,
    [EExpensesAnalyzerField.AMOUNT_LOCAL_MACRO]: colors.chartCostsTrafficChargesAtHomeMacroRegionAndNotInHomeRegion,
    [EExpensesAnalyzerField.AMOUNT_LOCAL]: colors.chartCostsTrafficChargesAtHomeRegion,
    [EExpensesAnalyzerField.AMOUNT_COUNTRY_ROAMING]: colors.chartCostsTrafficChargesAtOutHomeMacroRegion,
    [EExpensesAnalyzerField.AMOUNT_ROAMING]: colors.chartCostsTrafficChargesAtRoaming,
};
